// Module
var code = "<!DOCTYPE html> <div class=\"iw-time-range__info__popover__item\"></div>";
// Exports
export default code;